import { CodeSurfer, CodeSurferColumns, Step } from 'code-surfer';
import { Head, Image, Appear, Notes, Embed } from 'mdx-deck';
import { github } from '@code-surfer/themes';
import hasuratheme from "../../../../../../hasuraTheme";
import ts from "../../../../../../assets/ts.png";
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  Head: Head,
  Image: Image,
  Appear: Appear,
  Notes: Notes,
  Embed: Embed,
  github: github,
  hasuratheme: hasuratheme,
  ts: ts,
  React: React
};